import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const LinkText = styled.span<{ activeStyle: boolean }>`
  text-transform: capitalize;
  color: ${({ activeStyle }) =>
    activeStyle ? themeStyle.varInkMain : themeStyle.varInkMedium};

  &:hover {
    color: ${themeStyle.varInkMain};
  }
`;
